module.exports = __webpack_public_path__ + "static/img/1-04.8cf738e.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-04.png
// module id = 205
// module chunks = 0